var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoomIn = function SvgZoomIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7082 38.9657C26.3959 38.9657 29.8233 37.7075 32.5566 35.6251L40.0622 43.1307C40.4961 43.5645 41.0601 43.7815 41.5807 43.7815C42.1014 43.7815 42.7087 43.5645 43.0992 43.1307C43.9669 42.263 43.9669 40.9181 43.0992 40.0503L35.637 32.5447C37.7194 29.8114 38.9776 26.384 38.9776 22.6963C38.9776 13.7155 31.6889 6.42682 22.7082 6.42682C13.7274 6.42682 6.43872 13.7155 6.43872 22.6963C6.43872 31.677 13.7274 38.9657 22.7082 38.9657ZM22.7082 10.7653C29.2593 10.7653 34.6391 16.1017 34.6391 22.6963C34.6391 29.2908 29.2593 34.6272 22.7082 34.6272C16.157 34.6272 10.7772 29.2474 10.7772 22.6963C10.7772 16.1451 16.1136 10.7653 22.7082 10.7653Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7843 13.8235C23.8672 13.8235 24.7451 14.7014 24.7451 15.7843V29.7843C24.7451 30.8672 23.8672 31.7451 22.7843 31.7451C21.7014 31.7451 20.8236 30.8672 20.8236 29.7843V15.7843C20.8236 14.7014 21.7014 13.8235 22.7843 13.8235Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8236 22.7843C13.8236 21.7014 14.7014 20.8235 15.7843 20.8235H29.7843C30.8673 20.8235 31.7451 21.7014 31.7451 22.7843C31.7451 23.8672 30.8673 24.7451 29.7843 24.7451H15.7843C14.7014 24.7451 13.8236 23.8672 13.8236 22.7843Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-in.df0a74c1.svg";
export { ForwardRef as ReactComponent };